import React, { useState } from 'react';

const NoticeBar = () => {
  const [isPaused, setIsPaused] = useState(false);

  const notices = [
    {
      icon: "🎓",
      text: "2nd Graduation Ceremony – Save the Date! Friday, 2nd October 2026 at Karumo TTI Grounds",
      highlight: true,
    },
    {
      icon: "🎉",
      text: "Celebrating KARUMO@10 – A Decade of Excellence in Technical Education! Thank you for 10 years of transforming careers.",
      highlight: true,
    },
  ];

  return (
    <div className="fixed top-[7.5rem] left-0 right-0 z-40 w-full overflow-hidden bg-gradient-to-r from-primary via-primary/90 to-primary">
      {/* Gold accent stripe at top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400" />

      {/* Gold decorative dots on sides */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-yellow-300 animate-pulse hidden sm:block" />
      <div className="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-yellow-300 animate-pulse hidden sm:block" />

      <div
        className="flex items-center h-14 sm:h-16"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Pause indicator */}
        {isPaused && (
          <div className="absolute left-1/2 -translate-x-1/2 z-20 px-4 py-1 bg-yellow-300 text-primary text-xs font-bold rounded-full shadow-lg animate-fade-in whitespace-nowrap">
            ⏸ PAUSED
          </div>
        )}

        {/* Scrolling content */}
        <div
          className={`flex items-center gap-24 whitespace-nowrap ${isPaused ? 'animate-none' : 'animate-marquee'}`}
        >
          {/* Duplicate the notices for seamless loop */}
          {[...notices, ...notices].map((notice, idx) => (
            <span
              key={idx}
              className="inline-flex items-center gap-3 text-white text-sm sm:text-base md:text-lg font-medium tracking-wide"
            >
              <span className="text-yellow-300 text-lg sm:text-xl drop-shadow-sm">
                {notice.icon}
              </span>
              <span className="drop-shadow-sm">{notice.text}</span>
              <span className="w-2 h-2 rounded-full bg-yellow-300/60 mx-2" />
            </span>
          ))}
        </div>
      </div>

      {/* Bottom border glow */}
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-yellow-300/50 to-transparent" />
    </div>
  );
};

export default NoticeBar;

